import { render, staticRenderFns } from "./skrg_overview.vue?vue&type=template&id=9d66d0dc&scoped=true"
import script from "./skrg_overview.vue?vue&type=script&lang=js"
export * from "./skrg_overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d66d0dc",
  null
  
)

export default component.exports